import ApiService from "./ApiService"
import { comprimirFotosDe } from "utils/storeHube/comprimirFotos"


export async function apiGetTicketList (params) {
    const { query } = params
    return ApiService.fetchData({
        url: query,
        method: 'get',
        //params
    })
}

export async function apiGetTicketById (id) {
    return ApiService.fetchData({
        url: `/tickets/${id}`,
        method: 'get',
    })
}

export async function apiDeleteTicket (id) {
    return ApiService.fetchData({
        url: `/tickets/${id}`,
        method: 'delete',
    })
}


export async function apiPostTicket (data) {
    return ApiService.fetchData({
        url: `/tickets`,
        method: 'post',
        headers: { "Content-Type": "multipart/form-data" },
        data
    })
}

// Todas las respuestas de cuestionario con fotos pasan por acá (alta del ticket, cierre, inicio,
// en la vista nueva y en la vieja): las fotos se achican una sola vez, en este lugar.
export async function apiPostAnswerTicket (id, data) {
    return ApiService.fetchData({
        url: `/tickets/${id}/answers`,
        method: 'post',
        data: await comprimirFotosDe(data)
    })
}


export async function apiPutTicket (id, data) {
    return ApiService.fetchData({
        url: `/tickets/${id}`,
        method: 'put',
        data
    })
}


export async function apiTicketReplies (id, data) {
    return ApiService.fetchData({
        url: `/tickets/${id}/replies`,
        method: 'post',
        headers: { "Content-Type": "multipart/form-data" },
        data
    })
}

export async function apiTicketFavorite (id) {
    return ApiService.fetchData({
        url: `/tickets/${id}/favorite`,
        method: 'post',
    })
}

export async function apiGetTicketCategories(params) {
    const {query} = params
    return ApiService.fetchData({
        url: query ?? '/tickets/categories',
        method: 'get',
    })
}
export async function apiGetTicketCategoriesCrud() {
    return ApiService.fetchData({
        url: '/tickets_categories',
        method: 'get',
    })
}



export async function apiGetTicketStatus() {
    return ApiService.fetchData({
        url: '/tickets/status',
        method: 'get',
    })
}

export async function apiChangeSubscriptionTicket(id){
    return ApiService.fetchData({
        url: `/tickets/${id}/subscribe`,
        method: 'post'
    })
}

export async function apiTicketExpiration (data) {
    return ApiService.fetchData({
        url: `/tickets/expiration`,
        method: 'post',
        data
    })
}
export async function apiGetUsersAndStores() {
    return ApiService.fetchData({
        url: '/users/teams',
        method: 'get',
    })
}

// Candidatos para el autocomplete de menciones (@) del composer de comentarios.
// El backend acota la lista a los usuarios del equipo de la tienda del ticket y
// devuelve como maximo 10, asi que el filtrado va en el servidor y no aca.
export async function apiGetMentionableUsers(id, term, config = {}) {
    return ApiService.fetchData({
        url: `/tickets/${id}/mentionable-users`,
        method: 'get',
        params: { q: term },
        ...config,
    })
}

// Menciones que recibio el usuario logueado, para llenar la campanita al abrir
// la app. La campanita solo se llenaba con eventos de Pusher en vivo, y Pusher
// no tiene replay: sin esto, al mencionado que no tenia la pestana abierta no le
// quedaba forma de enterarse mas que el mail.
export async function apiGetMyMentions(config = {}) {
    return ApiService.fetchData({
        url: '/tickets/mentions',
        method: 'get',
        ...config,
    })
}

export async function apiGetUserStores(userId) {
    return ApiService.fetchData({
        url: `/users/teams?user=${userId}`,
        method: 'get',
    })
}

export async function apiGetAllUsers() {
    return ApiService.fetchData({
        url: '/users?all=true',
        method: 'get',
    })
}

export async function apiLinkTicket(id, data) {
    return ApiService.fetchData({
        url: `/tickets/${id}/link`,
        method: 'post',
        data
    })
}



//OLDS

export async function apiGetSalesDashboardData (data) {
    return ApiService.fetchData({
        url: '/tickets',
        method: 'get',
        data
    })
}

export async function apiGetSalesProducts (data) {
    return ApiService.fetchData({
        url: '/sales/products',
        method: 'post',
        data
    })
}

export async function apiDeleteSalesProducts (data) {
    return ApiService.fetchData({
        url: '/sales/products/delete',
        method: 'delete',
        data
    })
}

export async function apiPutSalesProduct (data) {
    return ApiService.fetchData({
        url: '/sales/products/update',
        method: 'put',
        data
    })
}

export async function apiCreateSalesProduct (data) {
    return ApiService.fetchData({
        url: '/sales/products/create',
        method: 'post',
        data
    })
}

export async function apiGetSalesOrders (params) {
    return ApiService.fetchData({
        url: '/sales/orders',
        method: 'get',
        params
    })
}

export async function apiDeleteSalesOrders (data) {
    return ApiService.fetchData({
        url: '/sales/orders/delete',
        method: 'delete',
        data
    })
}

export async function apiGetSalesOrderDetails (params) {
    return ApiService.fetchData({
        url: '/sales/orders-details',
        method: 'get',
        params
    })
}

export async function apiRotateImage (id, data) {
    return ApiService.fetchData({
        url: `/tickets/answer_file/${id}/`,
        method: 'post',
        data
    })
}

// Polling del resultado del analisis de IA de una respuesta AI_VISUAL_CHECK
// (ver storehub-api routes/tenant.php: GET answer_file/{ticket_answer}/visual_check_result).
export async function apiGetTicketAnswerVisualCheckResult (id) {
    return ApiService.fetchData({
        url: `/tickets/answer_file/${id}/visual_check_result`,
        method: 'get',
    })
}

// Reintento manual — el backend rechaza esto si el resultado no esta en
// status=failed (no tiene sentido reintentar un analisis pending/completed).
export async function apiRetryTicketAnswerVisualCheckResult (id) {
    return ApiService.fetchData({
        url: `/tickets/answer_file/${id}/visual_check_retry`,
        method: 'post',
    })
}
